import api from "./apiService";

export const getRequest = (page, limit, type) => {
  return api
    .get(`/admin/maintenance?page=${page}&limit=${limit}&status=${type}`)
    .then(data => {
      return data;
    })
    .catch(err => {
      throw err;
    });
};

export function getRequestDetail(id) {
  return api
    .get(`/admin/maintenance/${id}`)
    .then(data => {
      return data;
    })
    .catch(err => {
      throw err;
    });
}

export function declineRequest(id, payload) {
  return api
    .patch(`/admin/maintenance/decline-maintenance-request/${id}`, payload)
    .then(data => {
      return data;
    })
    .catch(err => {
      throw err;
    });
}

export function rejectRequestToDecline(id, payload) {
  return api
    .patch(`/admin/maintenance/reject-request-to-decline/${id}`, payload)
    .then(data => {
      return data;
    })
    .catch(err => {
      throw err;
    });
}

export function approveRequestToDecline(id) {
  return api
    .patch(`/admin/maintenance/approve-request-to-decline/${id}`)
    .then(data => {
      return data;
    })
    .catch(err => {
      throw err;
    });
}

export function acceptRequest(id, payload) {
  return api
    .patch(`/admin/maintenance/accept-maintenance-request/${id}`, payload)
    .then(data => {
      return data;
    })
    .catch(err => {
      throw err;
    });
}

export function followup(id, payload) {
  return api
    .patch(`/admin/maintenance/follow-up/${id}`, payload)
    .then(data => {
      return data;
    })
    .catch(err => {
      throw err;
    });
}

export function newAppointment(id, payload) {
  return api
    .patch(`/admin/maintenance/create-new-appointment/${id}`, payload)
    .then(data => {
      return data;
    })
    .catch(err => {
      throw err;
    });
}

export function followupOnEsc(id, payload) {
  return api
    .patch(`/admin/maintenance/follow-up-escalated-maintenance/${id}`, payload)
    .then(data => {
      return data;
    })
    .catch(err => {
      throw err;
    });
}

export function comment(id, payload) {
  return api
    .patch(`/admin/maintenance/comment/${id}`, payload)
    .then(data => {
      return data;
    })
    .catch(err => {
      throw err;
    });
}

export function completeRequest(id, payload) {
  return api
    .patch(`/admin/maintenance/complete-maintenance-request/${id}`, payload)
    .then(data => {
      return data;
    })
    .catch(err => {
      throw err;
    });
}

export function nudgeMember(id) {
  return api
    .patch(`/admin/maintenance/nudge-member/${id}`)
    .then(data => {
      return data;
    })
    .catch(err => {
      throw err;
    });
}

export function nudgeHost(id) {
  return api
    .patch(`/admin/maintenance/nudge-host/${id}`)
    .then(data => {
      return data;
    })
    .catch(err => {
      throw err;
    });
}

export function reopened(id, payload) {
  return api
    .patch(`/admin/maintenance/reopen-maintenance-request/${id}`, payload)
    .then(data => {
      return data;
    })
    .catch(err => {
      throw err;
    });
}

export function maintenanceSearchBy(id) {
  return api
    .get(`/maintenance/search?ticketId=${id}`)
    .then(data => {
      return data;
    })
    .catch(err => {
      throw err;
    });
}

export function getMaintenanceExportData(payload) {
  const params = new URLSearchParams();
  if (payload.status == "") {
    params.append("startDate", payload.startDate);
    params.append("endDate", payload.endDate);
  } else {
    params.append("startDate", payload.startDate);
    params.append("endDate", payload.endDate);
    params.append("status", payload.status);
  }

  return api
    .get(`/admin/maintenance/requests/export?`, { params })
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}



//////////////////
// WEBPACK FOOTER
// ./services/maintenance.js
// module id = null
// module chunks = 